import { render, staticRenderFns } from "./ActiveSubscription.vue?vue&type=template&id=155b8ade"
import script from "./ActiveSubscription.vue?vue&type=script&lang=ts"
export * from "./ActiveSubscription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports